import { createRoot } from "react-dom/client";
import { ChatView } from "../chat/ChatView";

export const initChatView = () => {
  const container = document.getElementById("chat-modal-content");

  if (container) {
    const root = createRoot(container);

    root.render(<ChatView caseId={container.dataset.caseId} userName={container.dataset.userName} />);
  }
};
